import React from 'react';
import { Grid, List, ListItem, ListItemText, Button, Link, Typography } from '@material-ui/core';
import imgLink from 'imagens/link-external.png'
import { Card1, Card2 } from 'components/Card';
import { useDevice } from 'components/DeviceContext.js';

const Normativas = () => {
    const { isMobile } = useDevice();
    const normativas = [
        { titulo: 'Constituição Federal', link: 'http://www.planalto.gov.br/ccivil_03/constituicao/constituicao.htm' },
        { titulo: 'Lei 8.069/1990- Estatuto da Criança e do Adolescente Lei 8.069/1990 (art. 88, inc. IV)', link: 'http://www.planalto.gov.br/ccivil_03/leis/l8069.htm' },
        { titulo: 'Lei 4.320/1964 – Institui Normas Gerais de Direito Financeiro para elaboração e controle dos orçamentos', link: 'http://www.planalto.gov.br/ccivil_03/LEIS/L4320.htm' },
        { titulo: 'Lei 12.594/2012 - Institui o Sistema Nacional de Atendimento Socioeducativo', link: 'http://www.planalto.gov.br/ccivil_03/_ato2011-2014/2012/lei/l12594.htm' },
        { titulo: 'Lei 13.431/2017 - Estabelece o sistema de garantia de direitos da criança e do adolescente vítima ou testemunha de violência e altera a Lei nº 8.069, de 13 de julho de 1990 (Estatuto da Criança e do Adolescente). ', link: 'https://www.planalto.gov.br/ccivil_03/_ato2015-2018/2017/lei/l13431.htm' },
        { titulo: 'Resoluções do Conanda ', link: 'https://www.gov.br/participamaisbrasil/https-wwwgovbr-participamaisbrasil-blob-baixar-7359' },
        // { titulo: 'Resolução do Conanda 194, de 10 de julho de 2017: inclui o parágrafo 2o do art. 16 da Resolução 137, de 21 de janeiro de 2010, estabelecendo formas para utilização dos recursos do FIA.', link: 'https://www.gov.br/participamaisbrasil/conanda/conanda/resolucoes/resolucao-no-194-de-10-de-julho-de-2017/view' },
        // { titulo: 'Instrução Normativa RFB 1.143, de 1o de abril de 2011', link: 'http://normas.receita.fazenda.gov.br/sijut2consulta/link.action?idAto=16115&visao=anotado' },
        // { titulo: 'Instrução Normativa RFB 1131, de 20 de fevereiro de 2011', link: 'http://normas.receita.fazenda.gov.br/sijut2consulta/link.action?idAto=16103&visao=anotado' },
    ];

    return (
        <Grid container style={{
                    justifyContent: 'space-around',
                    fontFamily: 'Open sans',
                    margin: isMobile ? '' : '2em 0 5em'

        }}>
            <Grid item xs={12} md={5} lg={4}
                style={{
                    padding: isMobile ? '3em 1em' : '0',

                }}>
                <Typography variant="h4" style={{
                    color: 'var(--azul)'
                }}>Normativas</Typography>
                <Typography style={{
                    color: 'var(--laranja)',
                    fontSize: isMobile ? '1em' : '1.3em'
                }}>Fique por dentro das normativas (legislação que estimula e dá competências):</Typography>
                <List>
                    <ListItem style={{
                        border: '2px solid var(--cinza)',
                        display: 'flex',
                        padding: '8px',
                        backgroundColor: 'var(--azul)',
                        borderRadius: '1em 1em 0 0'
                    }}>
                        <ListItemText primary="Título" style={{ color: 'var(--branco)', padding: '0.2em' }} />
                        <ListItemText primary="Link" style={{ textAlign: 'end', color: 'var(--branco)', padding: '0.2em' }} />
                    </ListItem>

                    {normativas.map((normativa, index) => (
                        <ListItem key={index} style={{
                            border: '2px solid var(--cinza)',
                        }}>
                            <ListItemText primary={normativa.titulo} />
                            <Button component={Link} href={normativa.link} target="_blank"><img src={imgLink} alt='imagem de link' /></Button>
                        </ListItem>
                    ))}
                </List>
                <Typography variant="body2" color="secondary" style={{
                    backgroundColor: 'var(--azul-claro)',
                    color: 'var(--azul-escuro)',
                    padding: '1em',
                    borderRadius: '0.6em'
                }}>
                    <span style={{
                        fontWeight: '700'
                    }}>IMPORTANTE!</span><br />
                    A Resolução 194/2017 do Conanda altera a Resolução 137, de 21 de Janeiro de 2010,
                    que dispõe sobre a criação e o funcionamento dos Fundos Nacional, Estadual, Distrital e
                    Municipal dos Direitos da Criança e do Adolescente. A nova Resolução inclui o parágrafo 2o do art. 16 da
                    Resolução 137/2010 <span style={{
                        fontWeight: '700'
                    }}>
                        e atribui aos conselhos dos Direitos da Criança e do Adolescente a responsabilidade
                        de deliberar, por resolução própria, a aplicação de recursos em aquisição, construção, reforma, manutenção
                        e/ou aluguel de imóveis públicos e/ou privados, desde que para uso exclusivo da política da infância e da
                        adolescência, observada a legislação de regência, incluindo a referida Resolução 194.
                    </span>
                </Typography>
            </Grid>
            <Grid item xs={12} md={5} lg={4}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    // justifyContent: 'center',
                    alignItems: 'center'
                }}>
                <Card1 />
                <Card2 />

            </Grid>
        </Grid>

    );
};

export default Normativas;
